import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Users } from './pages/Users';
import { Circles } from './pages/Circles';
import { Transactions } from './pages/Transactions';
import { Payouts } from './pages/Payouts';
import { Risk } from './pages/Risk';
import { Defaults } from './pages/Defaults';
import { UserDetail } from './pages/UserDetail';
import { CircleDetail } from './pages/CircleDetail';
import { Kyc } from './pages/Kyc';
import { OutstandingBalances } from './pages/OutstandingBalances';
import { WebhookEvents } from './pages/WebhookEvents';
import api from './api';

const Admins = () => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchAdmins(); }, []);

  const fetchAdmins = async () => {
    try {
      const res = await api.get('/admin/admins');
      setAdmins(res.data.data?.admins || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleRevoke = async (id) => {
    if (!window.confirm('Revoke admin access for this user?')) return;
    try {
      await api.put(`/admin/admins/${id}/status`, { isAdmin: false });
      fetchAdmins();
    } catch (err) {
      alert('Failed to update admin status');
    }
  };

  return (
    <div>
      <h1 className="page-title">Admin Users</h1>
      <div className="glass">
        <div className="table-container" style={{ border: 'none', borderRadius: '16px' }}>
          {loading ? (
            <div className="loader-container"><div className="spinner"></div></div>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>KYC Status</th>
                  <th>Last Login</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {admins.map(admin => (
                  <tr key={admin.id}>
                    <td style={{ fontWeight: 500 }}>{admin.firstName} {admin.lastName}</td>
                    <td style={{ color: 'var(--text-secondary)' }}>{admin.email}</td>
                    <td><span className={`badge ${admin.kycStatus?.toLowerCase()}`}>{admin.kycStatus}</span></td>
                    <td style={{ color: 'var(--text-secondary)' }}>{admin.lastLoginAt ? new Date(admin.lastLoginAt).toLocaleDateString() : 'Never'}</td>
                    <td>
                      {admin.email !== 'admin@cirupay.com' && (
                        <button className="btn-danger" onClick={() => handleRevoke(admin.id)}>Revoke Access</button>
                      )}
                    </td>
                  </tr>
                ))}
                {admins.length === 0 && (
                  <tr><td colSpan="5" style={{ textAlign: 'center', padding: '32px', color: 'var(--text-secondary)' }}>No admins found.</td></tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="users" element={<Users />} />
            <Route path="users/:id" element={<UserDetail />} />
            <Route path="circles" element={<Circles />} />
            <Route path="circles/:id" element={<CircleDetail />} />
            <Route path="risk" element={<Risk />} />
            <Route path="defaults" element={<Defaults />} />
            <Route path="transactions" element={<Transactions />} />
            <Route path="payouts" element={<Payouts />} />
            <Route path="kyc" element={<Kyc />} />
            <Route path="outstanding-balances" element={<OutstandingBalances />} />
            <Route path="webhooks" element={<WebhookEvents />} />
            <Route path="admins" element={<Admins />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
